import Link from 'launch/components/Link';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const TermsLink = () => (
    <Link href="/legal/terms-of-use" target="_blank" variations={['default']}>
        <FormattedMessage id="terms" />
    </Link>
);

export default TermsLink;



// WEBPACK FOOTER //
// ./js/launch/components/TermsLink.jsx